import React from "react";
import { MdClose } from "react-icons/md";
import { createPortal } from "react-dom";

import {
  Backdrop,
  ModalContainer,
  Head,
  Content,
} from "components/shared/Modal/Modal.style";
import { Typography } from "@mui/material";

function Modal(props) {
  return createPortal(
    <>
      <Backdrop isShown={props.show} onClick={props.onClose}>
        <ModalContainer onClick={(e) => e.stopPropagation()} isShown={props.show}>
          <Head>
            <MdClose fill="green" size={28} onClick={props.onClose} />
            {props.title}
          </Head>

          <Content>
            <Typography
              variant="p"
              component="p"
              color="primary.contrastText"
              fontSize={18}
            >
              {props.children}
            </Typography>
          </Content>
        </ModalContainer>
      </Backdrop>
    </>,
    document.getElementById("modal")
  );
}

export default Modal;
